import { render, staticRenderFns } from "./GridProjectId.vue?vue&type=template&id=99ba3466&scoped=true"
import script from "./GridProjectId.vue?vue&type=script&lang=js"
export * from "./GridProjectId.vue?vue&type=script&lang=js"
import style0 from "./GridProjectId.vue?vue&type=style&index=0&id=99ba3466&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99ba3466",
  null
  
)

export default component.exports